require('./myProfileSecurityKitChangeView.scss');
// @ vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const { FormattedText, formatText, getFinalTitle } = require('core/i18n').i18n;
// @actions
const {
    changeKitStart,
    getKits,
    reset,
    setVisibleStep,
    validateStep
} = require('actions/myProfileSecurityKitChange');

// @ commons
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKIconIllustrative } = require('commonsComponents/OKIconIllustrative');
// @components
const ContactInfoBox = require('components/myProfile/contactInfoBox/contactInfoBox');
const { MyProfileSecurityKitChange } = require('components/myProfile/myProfileSecurityKitChange/myProfileSecurityKitChange');
const { MyProfileSecurityKitResume } = require('components/myProfile/myProfileSecurityKitChange/myProfileSecurityKitResume/myProfileSecurityKitResume')
const MyProfileSecurityKitChangeErrorEnd = require('components/myProfile/myProfileSecurityKitChange/myProfileKitChangeSubmit/myProfileSecurityKitChangeErrorEnd');
const MyProfileSecurityKitChangeSubmitView = require('components/myProfile/myProfileSecurityKitChange/myProfileKitChangeSubmit/myProfileSecurityKitChangeSubmitView');
const MyProfileSecurityKitChangeSuccessEnd = require('components/myProfile/myProfileSecurityKitChange/myProfileKitChangeSubmit/myProfileSecurityKitChangeSuccessEnd');
// @ constants
const infoIcon = require('assets/images/icon-info-blue.svg'); //@hardcoded: replace Icon placeholder
const STEP_RESUME = 'STEP_RESUME'
const STEP_CHANGE = 'STEP_CHANGE'

class MyProfileSecurityKitChangeView extends React.Component {
    constructor(props) {
        super(props);

        this.handleCancel = this.handleCancel.bind(this);
        this.state = {
            step: STEP_RESUME,
        }
    }

    componentWillMount() {
        const { getKits, immMyProfileSecurityKitChange } = this.props;
        !immMyProfileSecurityKitChange.get('defaultKit') && getKits();
    }

    componentWillUnmount() {
        const { reset } = this.props;
        reset();
    }

    handleCancel() {
        const redirectUrl = __CONTACT_CENTER__ ? '/myprofile' : '/myprofile/keys';
        this.props.history.push(redirectUrl);
    }

    handleEditButtonClick() {
        const {changeKitStart} = this.props
        changeKitStart();
        this.setState({ step: STEP_CHANGE})
    }

    renderSubmit() {
      const { immMyProfileSecurityKitChange } = this.props;
      const errorReceived = immMyProfileSecurityKitChange.get('errorReceived');
      const submitSuccessful = immMyProfileSecurityKitChange.get('submitSuccessful');
      const sets = immMyProfileSecurityKitChange.get('sets')
      const referenceKits = immMyProfileSecurityKitChange.get('referenceKits')
      if (submitSuccessful && !errorReceived) {
          return (
              <MyProfileSecurityKitChangeSubmitView>
                  <MyProfileSecurityKitChangeSuccessEnd
                      sets={sets}
                      referenceKits={referenceKits}
                  />
              </MyProfileSecurityKitChangeSubmitView>
          )
      }

      return (
          <MyProfileSecurityKitChangeSubmitView>
              <MyProfileSecurityKitChangeErrorEnd />
          </MyProfileSecurityKitChangeSubmitView>
      )
    }

    renderKitChange() {
      const {
        immMyProfileSecurityKitChange,
        isNerudaUser,
        setVisibleStep,
        validateStep,
      } = this.props;
      let boxBodyResume2;

      if (!isNerudaUser) {
        boxBodyResume2 = (
            <li className="contact-info-box__list-item">
                <FormattedText
                    className="contact-info-box__list-item-value"
                    value="securityKit-boxBodyResume2"
                />
            </li>
        );
      }
      const boxBodyResume = (
          <div>
              <div className="security-kit-view__info-icon">
                  <OKIconIllustrative icon="info" product="banking" />
              </div>
              <ul className="contact-info-box__list">
                  <li className="contact-info-box__list-item">
                      <FormattedText
                          className="contact-info-box__list-item-value"
                          value="securityKit-boxBodyResume1"
                      />
                  </li>
                  {boxBodyResume2}
                  <li className="contact-info-box__list-item">
                      <FormattedText
                          className="contact-info-box__list-item-value"
                          value="securityKit-boxBodyResume3"
                      />
                  </li>
                  <li className="contact-info-box__list-item">
                      <FormattedText
                          className="contact-info-box__list-item-value"
                          value="securityKit-boxBodyResume4"
                      />
                  </li>
              </ul>
          </div>
      );
      const titleBreadcrumb = (this.state.step === STEP_RESUME ? 'securityKit-titleResumeBreadcrumb' : 'securityKit-titleBreadcrumb')
      const titleHeader = (this.state.step === STEP_RESUME ? 'securityKit-titleResumeHeader' : 'securityKit-titleHeader')
      const mappingBreadcrumb = !__CONTACT_CENTER__ ? [
          {
              text: formatText('profileKeysLanding-title'),
              url: '/myprofile/keys'
          },
          {
              text: formatText(titleBreadcrumb),
              url: ''
          }
      ] : [];

      return (
          <div>
              <div className="container-fluid">
                  <div className="row">
                      <OKCover size="medium" section="pg" customClass="col-xs-12">
                          <OKHeaderSubPage
                              breadcrumbConfig={mappingBreadcrumb}
                              finalTitle={getFinalTitle(titleHeader)}
                          />
                      </OKCover>
                  </div>
              </div>
              <div className="grid-view__body">
                  <div className="container-fluid">
                      <div className="row grid-view--content-position-negative">
                          <div className="col-xs-12 col-md-8">
                              <div className="row">
                                  <div className="col-md-12">
                                      {this.state.step === STEP_CHANGE &&
                                          <MyProfileSecurityKitChange
                                              immMyProfileSecurityKitChange={immMyProfileSecurityKitChange}
                                              isNerudaUser={isNerudaUser}
                                              validateStep={validateStep}
                                              setVisibleStep={setVisibleStep}
                                              onCancel={this.handleCancel}
                                          />}
                                      {this.state.step === STEP_RESUME &&
                                          <MyProfileSecurityKitResume
                                              immMyProfileSecurityKitChange={immMyProfileSecurityKitChange}
                                              handleEditButtonClick={() => this.handleEditButtonClick()}
                                              isNerudaUser={isNerudaUser}
                                          />}
                                  </div>
                              </div>
                          </div>
                          <div className="col-xs-12 col-md-4">
                              <div className="row">
                                  <div className="col-xs-12 grid-view--variable-cell-separation">
                                      <ContactInfoBox
                                          boxTitle={formatText('securityKit-boxTitleResume')}
                                          boxBody={boxBodyResume}
                                          icon={infoIcon}
                                      />
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      );
    }

    render() {
      const { immMyProfileSecurityKitChange } = this.props;
      const submitSuccessful = immMyProfileSecurityKitChange.get('submitSuccessful')
      if(submitSuccessful) {
        return this.renderSubmit()
      }

      return this.renderKitChange()
    }
}

MyProfileSecurityKitChangeView.propTypes = {
    changeKitStart: PropTypes.func.isRequired,
    getKits: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immMyProfileSecurityKitChange: PropTypes.object.isRequired,
    isNerudaUser: PropTypes.bool.isRequired,
    reset: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired
}

function mapStateToProps(state) {
    return {
        immMyProfileSecurityKitChange: state.myProfileSecurityKitChange,
        isNerudaUser: state.profile.get('isNerudaUser'),
    };
}

const mapDispatchToProps = {
    changeKitStart,
    getKits,
    reset,
    setVisibleStep,
    validateStep
}

module.exports.constructor = MyProfileSecurityKitChangeView;
module.exports.MyProfileSecurityKitChangeView = connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(MyProfileSecurityKitChangeView));
